import { Home } from "../home/Home";
import { Sobre } from "../sobre/Sobre";
import { ComplaintLanding } from "../complaint/ComplaintLanding";
import { AnonymousComplaint } from "../complaint/AnonymousComplaint";
import { IdentifiedComplaint } from "../complaint/IdentifiedComplaint";
import { ComplaintTracking } from "../complaint/ComplaintTracking";
import { ReclamationLanding } from "../reclamation/ReclamationLanding";
import { ReclamationForm } from "../reclamation/ReclamationForm";
import { ReclamationSuccessPage } from "../reclamation/ReclamationSuccessPage";
import { MyCasesList } from "../my-cases/MyCasesList";
import { MyCaseDetail } from "../my-cases/MyCaseDetail";
import { SupplierResponse } from "../supplier/SupplierResponse";
export var appRoutes = [
    { path: "/", component: Home, protected: false, layout: "public" },
    { path: "/sobre", component: Sobre, protected: false, layout: "public" },
    {
        path: "/complaint",
        component: ComplaintLanding,
        protected: false,
        layout: "public",
    },
    {
        path: "/complaint/anonymous",
        component: AnonymousComplaint,
        protected: false,
        layout: "public",
    },
    {
        path: "/complaint/identified",
        component: IdentifiedComplaint,
        protected: true,
        layout: "public",
    },
    {
        path: "/complaint/tracking",
        component: ComplaintTracking,
        protected: false,
        layout: "public",
    },
    {
        path: "/reclamation",
        component: ReclamationLanding,
        protected: false,
        layout: "public",
    },
    {
        path: "/reclamation/form",
        component: ReclamationForm,
        protected: true,
        layout: "public",
    },
    {
        path: "/reclamation/success",
        component: ReclamationSuccessPage,
        protected: false,
        layout: "public",
    },
    {
        path: "/my-cases",
        component: MyCasesList,
        protected: true,
        layout: "citizen",
    },
    {
        path: "/my-cases/:id",
        component: MyCaseDetail,
        protected: true,
        layout: "citizen",
    },
    {
        path: "/supplier/response/:id",
        component: SupplierResponse,
        protected: false,
        layout: "public",
    },
];
